import controller from './battery-status.controller';

const template = require('./battery-status.html');

export default {
    bindings: {
        battery: '<'
    },
    template,
    controller
};



// WEBPACK FOOTER //
// ./app/common/battery-status/battery-status.component.js